// @file Helper functions for billing components.
import { UpgradeStep } from 'vuexstore/modules/plans'

export function getUpgradeStepFromQuota(currentUserQuota): UpgradeStep {
  if (currentUserQuota.walls_used === currentUserQuota.walls_limit) return UpgradeStep.AtPadletQuota
  else if (currentUserQuota.walls_used < currentUserQuota.walls_limit) return UpgradeStep.BelowPadletQuota
  return UpgradeStep.OverPadletQuota
}

export function normalizedPaymentSchedule(paymentSchedule: string): 'monthly' | 'annual' {
  return paymentSchedule === 'month' ? 'monthly' : 'annual'
}
